/**
 * Export loadData calls from ducks modules of different containers
 */
import { loadData as AuthenticationPageLoader } from './AuthenticationPage/AuthenticationPage.duck';
import { loadData as AssociatedListingPageLoader } from './AssociatedListingPage/AssociatedListingPage.duck';
import { loadData as BrandOfferingPageLoader } from './BrandOfferingPage/BrandOfferingPage.duck';
import { loadData as BulkUploadUsersPageLoader } from './BulkUploadUsersPage/BulkUploadUsersPage.duck';
import { loadData as LandingPageLoader } from './LandingPage/LandingPage.duck';
import { loadData as CampaignPostingPageLoader } from './CampaignPostingPage/CampaignPostingPage.duck';
import { setInitialValues as CheckoutPageInitialValues } from './CheckoutPage/CheckoutPage.duck';
import { loadData as CMSPageLoader } from './CMSPage/CMSPage.duck';
import { loadData as ContactDetailsPageLoader } from './ContactDetailsPage/ContactDetailsPage.duck';
import { loadData as EditListingPageLoader } from './EditListingPage/EditListingPage.duck';
import { loadData as EmailVerificationPageLoader } from './EmailVerificationPage/EmailVerificationPage.duck';
import { loadData as FavoritesPageLoader } from './FavoritesPage/FavoritesPage.duck';
import { loadData as FavoritesDetailsPageLoader } from './FavoritesDetailsPage/FavoritesDetailsPage.duck';
import { loadData as InboxPageLoader } from './InboxPage/InboxPage.duck';
import { loadData as JobPostPageLoader } from './JobPostPage/JobPostPage.duck';
import { loadData as LinkTalentPageLoader } from './LinkTalentPage/LinkTalentPage.duck';
import { loadData as ListingPageLoader } from './ListingPage/ListingPage.duck';
import { loadData as ManageListingsPageLoader } from './ManageListingsPage/ManageListingsPage.duck';
import { loadData as ManageSubscriptionPageLoader } from './ManageSubscriptionPage/ManageSubscriptionPage.duck';
import { loadData as MessagesPageLoader } from './MessagesPage/MessagesPage.duck';
import { loadData as OrdersListViewPageLoader } from './OrdersListViewPage/OrdersListViewPage.duck';
import { loadData as PaymentMethodsPageLoader } from './PaymentMethodsPage/PaymentMethodsPage.duck';
import { loadData as PhylloConnectPageLoader } from './PhylloConnectPage/PhylloConnectPage.duck';
import { loadData as PerksPostPageLoader } from './PerksPostPage/PerksPostPage.duck';
import { loadData as PrivacyPolicyPageLoader } from './PrivacyPolicyPage/PrivacyPolicyPage.duck';
import { loadData as ProfilePageLoader } from './ProfilePage/ProfilePage.duck';
import { loadData as ReferralPageLoader } from './ReferralPage/ReferralPage.duck';
import { loadData as RewardsPageLoader } from './RewardsPage/RewardsPage.duck';
import { loadData as SearchPageLoader } from './SearchPage/SearchPage.duck';
import { loadData as ServiceOfferingsPageLoader } from './ServiceOfferingsPage/ServiceOfferingsPage.duck';
import { loadData as StripePayoutPageLoader } from './StripePayoutPage/StripePayoutPage.duck';
import { loadData as SubscriptionPageLoader } from './SubscriptionPage/SubscriptionPage.duck';
import { loadData as TalentOfferingPageLoader } from './TalentOfferingPage/TalentOfferingPage.duck';
import { loadData as TermsOfServicePageLoader } from './TermsOfServicePage/TermsOfServicePage.duck';
import {
  loadData as TransactionPageLoader,
  setInitialValues as TransactionPageInitialValues,
} from './TransactionPage/TransactionPage.duck';

const getPageDataLoadingAPI = () => {
  return {
    AuthenticationPage: {
      loadData: AuthenticationPageLoader,
    },
    AssociatedListingPage: {
      loadData: AssociatedListingPageLoader,
    },
    BrandOfferingPage: {
      loadData: BrandOfferingPageLoader,
    },
    BulkUploadUsersPage: {
      loadData: BulkUploadUsersPageLoader,
    },
    LandingPage: {
      loadData: LandingPageLoader,
    },
    CheckoutPage: {
      setInitialValues: CheckoutPageInitialValues,
    },
    CampaignPostingPage: {
      loadData: CampaignPostingPageLoader,
    },
    CMSPage: {
      loadData: CMSPageLoader,
    },
    ContactDetailsPage: {
      loadData: ContactDetailsPageLoader,
    },
    EditListingPage: {
      loadData: EditListingPageLoader,
    },
    EmailVerificationPage: {
      loadData: EmailVerificationPageLoader,
    },
    FavoritesPage: {
      loadData: FavoritesPageLoader,
    },
    FavoritesDetailsPage: {
      loadData: FavoritesDetailsPageLoader,
    },
    InboxPage: {
      loadData: InboxPageLoader,
    },
    JobPostPage: {
      loadData: JobPostPageLoader,
    },
    ListingPage: {
      loadData: ListingPageLoader,
    },
    LinkTalentPage: {
      loadData: LinkTalentPageLoader,
    },
    ManageListingsPage: {
      loadData: ManageListingsPageLoader,
    },
    ManageSubscriptionPage: {
      loadData: ManageSubscriptionPageLoader,
    },
    MessagesPage: {
      loadData: MessagesPageLoader,
    },
    OrdersListViewPage: {
      loadData: OrdersListViewPageLoader,
    },
    PaymentMethodsPage: {
      loadData: PaymentMethodsPageLoader,
    },
    PerksPostPage: {
      loadData: PerksPostPageLoader,
    },
    PhylloConnectPage: {
      loadData: PhylloConnectPageLoader,
    },
    PrivacyPolicyPage: {
      loadData: PrivacyPolicyPageLoader,
    },
    ProfilePage: {
      loadData: ProfilePageLoader,
    },
    ReferralPage: {
      loadData: ReferralPageLoader,
    },
    RewardsPage: {
      loadData: RewardsPageLoader,
    },
    SearchPage: {
      loadData: SearchPageLoader,
    },
    ServiceOfferingsPage: {
      loadData: ServiceOfferingsPageLoader,
    },
    StripePayoutPage: {
      loadData: StripePayoutPageLoader,
    },
    SubscriptionPage: {
      loadData: SubscriptionPageLoader,
    },
    TermsOfServicePage: {
      loadData: TermsOfServicePageLoader,
    },
    TalentOfferingPage: {
      loadData: TalentOfferingPageLoader,
    },
    TransactionPage: {
      loadData: TransactionPageLoader,
      setInitialValues: TransactionPageInitialValues,
    },
  };
};

export default getPageDataLoadingAPI;
